import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlertIcon } from 'lucide-react';
import { legalItems } from '../data/legal';
export function LegalNotice() {
  return <section id="aviso-legal" aria-labelledby="aviso-legal-titulo" className="border-t border-sage-200 bg-ivory-100" data-id="element-56" data-mp="1iio3nteamaoy">
      <div className="mx-auto max-w-4xl px-5 py-16 lg:px-8 lg:py-20" data-id="element-57" data-mp="1nishtcrqatc0">
        <div className="flex items-center gap-3" data-id="element-58" data-mp="1sh3x430slw1m">
          <ShieldAlertIcon className="h-5 w-5 text-gold-600" aria-hidden="true" data-id="element-59" data-mp="1sglos80uvrdc" />
          <h2 id="aviso-legal-titulo" className="font-display text-xl font-semibold uppercase tracking-[0.12em] text-emerald-900 sm:text-2xl" data-id="element-60" data-mp="1wh4ik7mb77i6">
            Aviso legal
          </h2>
        </div>

        <ul className="mt-7 space-y-4" data-id="element-61" data-mp="26acxxfaod98j">
          {legalItems.map(item => <li key={item} className="border-l-2 border-gold-400/70 pl-4 text-sm leading-relaxed text-graphite-700" data-id="element-62" data-mp="2b8wknhx3ep1y">
              {item}
            </li>)}
        </ul>

        <div className="mt-8 flex flex-wrap gap-x-8 gap-y-3" data-id="element-63" data-mp="1kg2ugq67v41c">
          <Link to="/terminos-y-condiciones" className="text-sm font-semibold uppercase tracking-[0.12em] text-emerald-700 underline underline-offset-4 hover:text-gold-600" data-id="element-64" data-mp="1fikwtvxngb8n">
            Términos y Condiciones
          </Link>
          <Link to="/politica-de-privacidad" className="text-sm font-semibold uppercase tracking-[0.12em] text-emerald-700 underline underline-offset-4 hover:text-gold-600" data-id="element-65" data-mp="238njtxmpir0e">
            Política de Privacidad
          </Link>
        </div>
      </div>
    </section>;
}